/* =========================================================================
   LW24 · V5 Scroll-Reveal Init (Pattern D)
   Deploy: als assets/lw-v5-reveal.js im Theme ablegen.
   Einbinden: in theme.liquid kurz vor </body>:
     {{ 'lw-v5-reveal.js' | asset_url | script_tag }}
   ========================================================================= */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }
  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -64px 0px' });

  function attach() {
    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
      if (!el.classList.contains('is-visible')) io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
  // Theme-Editor: nach Section-Reload erneut attachen
  document.addEventListener('shopify:section:load', attach);
})();